import { useUserAccounts } from "../../../../dataHooks/user"

export const useDirectClientAccounts = () => {
  const clients = useUserAccounts();

  return clients.filter((c) => c.isDirectClient);
}